import {
  IconBuildingWarehouse,
  IconCircleCheck,
  IconFileText,
  IconMapPin,
} from "@tabler/icons-react";

const WarehouseCard = ({
  props,
  onClick,
}: {
  props?: any;
  onClick?: () => void;
}) => {
  const {
    name = "",
    description = "",
    enable = false,
    address = {},
  } = props || {};

  const formattedAddress = address
    ? `${address.city || ""}${address.district || ""}${address.address || ""}`
    : "";

  return (
    <div
      className="cursor-pointer rounded-xl border border-gray-200 bg-white p-5 shadow-sm transition-shadow hover:shadow-md"
      onClick={onClick}
    >
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50 text-blue-600">
          <IconBuildingWarehouse size={20} />
        </div>
        <div
          className="truncate text-lg font-semibold"
          style={{ color: "#6F6F6F" }}
        >
          {name || "—"}
        </div>
      </div>
      <div className="mt-4 space-y-2 text-sm text-gray-600">
        {description ? (
          <div className="flex items-center gap-2">
            <IconFileText size={15} className="text-gray-400" />
            <span className="truncate">{description}</span>
          </div>
        ) : null}
        {formattedAddress ? (
          <div className="flex items-center gap-2">
            <IconMapPin size={15} className="text-gray-400" />
            <span className="truncate">{formattedAddress}</span>
          </div>
        ) : null}
        <div className="flex items-center gap-2">
          <IconCircleCheck
            size={15}
            className={enable ? "text-green-500" : "text-gray-300"}
          />
          <span>{enable ? "啟用" : "停用"}</span>
        </div>
      </div>
    </div>
  );
};

export default WarehouseCard;
